import { FormattedMessage } from "react-intl";
import { Heading } from "@lendcord/concord";
import { ProfileField } from "@/features/profile/components/ProfileField";

// Mirrors EmploymentSection's own "has employment" view-mode grid (the more
// common case) so the loading footprint matches the most likely loaded
// shape — see docs/design-system.md's "Loading states" section.
export function EmploymentSectionSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <Heading level={3}>
        <FormattedMessage id="lender.profile.employmentDetailsHeading" />
      </Heading>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ProfileField labelId="lender.profile.employmentTypeLabel" value="" loading />
        <ProfileField labelId="lender.profile.monthlyIncomeLabel" value="" loading />
        <ProfileField labelId="lender.profile.employerNameLabel" value="" loading />
        <ProfileField labelId="lender.profile.designationLabel" value="" loading />
      </div>
    </div>
  );
}
